import { ReadUserApiResponse } from '../../types/__domain__/identity'
import { get } from '../api/axiosClient'

export const readUser = async (): Promise<ReadUserApiResponse> => {
    let url = `/api/account/user-info`

    const response = await get(url)
    return response?.data
}
